export default {"src":"/_next/static/media/circle-frame.782571e4.svg","height":199,"width":199};